export const SUGGESTED_SPECIALTY = {
	generalAdult: {
		code: '1',
		description: 'Clínico Geral',
		telemedicine: '',
		formattedText: 'Clínico Geral',
		sub_code: '',
	},
	generalAdultOdonto: {
		code: '522',
		description: 'Odontologia Clínica',
		telemedicine: '',
		formattedText: 'Odontologia Clínica Geral',
		sub_code: '3',
	},
	generalPediatricOdonto: {
		code: '528',
		description: 'Odontopediatria',
		telemedicine: '',
		formattedText: 'Odontopediatria Geral',
		sub_code: '5',
	},
	generalPediatric: {
		code: '10',
		description: 'Pediatria',
		telemedicine: '',
		formattedText: 'Pediatria',
		sub_code: '',
	},
};
